export class EducationCenterCategory {
  id: number;
  name: string;
  course_ids: string;
  enabled: boolean;
  created_at: Date;
  updated_at: Date;
}
